import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoaderService } from '../loader/loader.service';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { IPolicy } from '../_models/compliance';
import { AuthenticationService } from './authentication.service';
import { User } from '../_models';
import { AppConfig } from 'src/assets/config/config/app-config';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  }),
  observe: 'response' as 'body'
};

@Injectable({
  providedIn: 'root'
})
export class HoldsService {
apiUrl:string
  constructor(
    private http: HttpClient,
    private config:AppConfig
    //private authenticationService: AuthenticationService,
    //private messageService: MessageService,
    // private snackBar: MatSnackBar,
    // private loader: LoaderService
  ) {
    //this.currentUser = this.authenticationService.currentUserValue;
    this.apiUrl=this.config.getConfig('apiUrl')
  }

  errorHandler(error: HttpErrorResponse) {
    return throwError(error)
  }

  getHoldGroups() {
    return this.http.get<any>(this.apiUrl+`/compliance/hold-groups`).pipe(catchError(this.errorHandler))
  }

  createHold(createData) {
    var createHoldBody = {
      name: createData.name,
      description: createData.description
    }
    return this.http.post<any>(this.apiUrl+`/compliance/hold-groups/create`, createHoldBody)
      .pipe(catchError(this.errorHandler))
  }

  applyHold(applyHoldData) {
    return this.http.post<any>(this.apiUrl+`/compliance/holds/apply`, applyHoldData).pipe(map(obj => { }),
      (catchError(this.errorHandler)))
      .pipe(catchError(this.errorHandler))
  }

  removeHold(payload) {
    return this.http.post<any>(this.apiUrl+`/compliance/holds/remove`, payload).pipe(map(obj => { }),
      (catchError(this.errorHandler)))
      .pipe(catchError(this.errorHandler))
  }
}